import { IController, ILocationService } from 'angular';
import * as _ from 'lodash';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';
import { IFilter, TValidSdcViews } from '../../../sdc/sdc-state/sdc-state.typings';
import { GraduationDate, IGraduationDate } from './../../../../ng2/shared/constants/graduation-date.constant';
import { SdcActionsService } from './../../../sdc/flux/sdc-actions.service';
import { ISdcStore } from './../../../sdc/flux/sdc-store.interface';

type TDiplomaType = 'Advanced Regents' | 'Regents' | 'Local';

interface IDropDown {
  gradPlans: string[];
  human: string;
}

export class PlannedGraduationDropdownCtrl implements IController {
  static inject: string[] = ['$scope', 'SDCStore', 'sdcActions', '$location', 'ObjectCache', 'ImSchool'];

  public uiReady: boolean = false;
  public sdcView: TValidSdcViews = 'wizard';
  public nextFourGradDates: IGraduationDate[];
  public dropdownOptions: IDropDown[];
  public selectedGradDate: IDropDown | null;
  private sdcDefaultFilter: IFilter;
  private sdcGradDateFilter: string[];

  constructor(
    private $scope,
    private SDCStore: ISdcStore,
    private sdcActions: SdcActionsService,
    private $location: ILocationService,
    private ObjectCache,
    private ImSchool: ImSchool,
  ) {}

  $onInit(): void {
    this.$scope.$listenTo(this.SDCStore, ['ui', 'isLoading'], () => {
      const isLoading = this.SDCStore.getUiState().isLoading;
      if (!isLoading) {
        this.setUi();
        this.uiReady = true;
      }
    });
  }

  setUi() {
    this.sdcDefaultFilter = this.SDCStore.getFilter();
    this.sdcGradDateFilter = this.sdcDefaultFilter.gradPlan ? this.sdcDefaultFilter.gradPlan : null;
    this.nextFourGradDates = this.ImSchool.getNextFourGradDatesForTransfer();
    this.dropdownOptions = this.generateDropdown(this.nextFourGradDates);
    this.selectedGradDate = this.sdcGradDateFilter
      ? _.find(this.dropdownOptions, { gradPlans: this.sdcGradDateFilter })
      : null;
  }

  filterSDCStudentsByGradDate(dropdownItem: IDropDown) {
    let gradDateFilter;
    let newFilter;
    const sdcView = this.sdcView;
    const sdcKey = this.SDCStore.getSdcKeyFromUiState();

    if (dropdownItem) {
      delete this.sdcDefaultFilter.gradPlan;
      const { gradPlans } = dropdownItem;
      gradDateFilter = { gradPlan: gradPlans };
      newFilter = _.merge(this.sdcDefaultFilter, gradDateFilter);
      this.sdcActions.setEntireFilter({ newFilter, sdcKey, sdcView });
      this.setFilterParam(newFilter);
    } else {
      delete this.sdcDefaultFilter.gradPlan;
      newFilter = this.sdcDefaultFilter;
      this.sdcActions.setEntireFilter({ newFilter, sdcKey, sdcView });
      this.setFilterParam(this.sdcDefaultFilter);
    }
  }

  private generateDropdown(nextFourGradDates): IDropDown[] {
    const gradDatesArray = _.toArray(GraduationDate);
    const lastDate = _.last(this.nextFourGradDates);
    const indexOfLastDate = _.findIndex(gradDatesArray, lastDate);
    const diplomaTypes = ['Local', 'Regents', 'Advanced Regents'];

    const beyondLastTermGradPlans = _.reduce(
      _.slice(gradDatesArray, indexOfLastDate + 1),
      (result, { humanName }) => {
        _.each(diplomaTypes, (diploma: TDiplomaType) => result.push(`${diploma} ${humanName}`));
        return result;
      },
      [],
    );

    const beyondDatesDropdownOption = [
      {
        gradPlans: beyondLastTermGradPlans,
        human: `Planned Beyond ${lastDate.humanName} Grad`,
      },
    ];

    const nextFourTermsDropdownOptions = _.map(nextFourGradDates, ({ humanName }) => {
      const gradPlans = [];
      _.each(diplomaTypes, diploma => gradPlans.push(`${diploma} ${humanName}`));
      return { gradPlans, human: `Planned ${humanName} Grad` };
    });
    return [...nextFourTermsDropdownOptions, ...beyondDatesDropdownOption];
  }

  private setFilterParam(filter: IFilter): void {
    const filterHash = this.ObjectCache.cacheObject(filter);
    this.$location.search('filter', filterHash).replace();
  }
}
